import add from './add';
import get from './get';
import remove from './remove';
import update from './update';
import { combineReducers } from 'redux';

const reducers = {
    add,
    get,
    update,
    remove,
};

const shoppingCart = combineReducers(reducers);

export default shoppingCart;


